import ScalarCombobox_vue_vue_type_script_setup_true_lang_default from "./ScalarCombobox.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarCombobox/ScalarCombobox.vue
var ScalarCombobox_default = ScalarCombobox_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarCombobox_default as default };

//# sourceMappingURL=ScalarCombobox.vue.js.map